import React, { FC, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import cx from 'classnames'
import { Icon } from 'components/Icon'
import { Widgets } from './components/Widgets'
import { Layers } from './components/Layers'
import { ProjectInfo } from './components/ProjectInfo'
import { LayerGroup } from 'models/layer'
import { Flex } from 'components/Flex'
import { Project, Area } from 'models/project'
import { isEmpty } from 'ramda'
import { Divider } from 'components/Divider'
import { Logo } from 'features/shared/Logo'
import styles from './Panel.module.scss'
import { Tooltip } from 'components/Tooltip'
import { useTranslation } from 'react-i18next'
import { useUserContext } from 'context/user-context'
import { ApiProvider } from 'providers/request'

enum Views {
  Layers,
  Widgets,
  Mixed,
  Expanded,
}

type PanelProps = {
  layers: LayerGroup[]
  project?: Project
  area?: Area
}

export const Panel: FC<PanelProps> = ({ layers, project, area }) => {
  const { t } = useTranslation()
  const { projectId } = useParams()

  const [hidden, setHidden] = useState(false)
  const [view, setView] = useState<Views>(Views.Layers)
  const loading = (projectId && !project) || !layers
  const showLayers = [Views.Layers, Views.Mixed, Views.Expanded].includes(view)
  const showWidgets = [Views.Widgets, Views.Mixed, Views.Expanded].includes(view)
  const doubleWidgets = [Views.Widgets, Views.Expanded].includes(view)
  const [currentUser] = useUserContext()

  const panelClasses = cx({
    [styles.panel]: true,
    [styles.hidden]: hidden,
  })

  useEffect(() => {
    const view = project && project.activeLayers.length > 0 ? Views.Mixed : Views.Layers
    setView(view)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps




  const monitoreoPanel = async (e: any) => {
    var currentButton = e;

    // Post currentButton to API logic
    switch (currentButton) {
      case "btn1":
        var button_id1 = "1";
        var u_id1 = currentUser?.id

        try {
          //var url2 = `https://0c58djfkue.execute-api.us-east-1.amazonaws.com/production/button/${button_id}/${u_id}`;
          ApiProvider.post(`/button/${button_id1}/${u_id1}`)
          /*const data = await fetch(url2)
          const resp = await data.json()
          if (resp[0].status === "success") {
            console.log("La api devolvio success.")
          } else {
            console.log("La api NO devolvio success.")
          } */
        } catch (err) {
          console.log("Error en el control de clicks. " + err)
        }
        setView(Views.Layers)
        break;
      case "btn2":
        var button_id2 = "2";
        var u_id2 = currentUser?.id

        try {
          ApiProvider.post(`/button/${button_id2}/${u_id2}`)
        } catch (err) {
          console.log("Error en el control de clicks.")
        }
        setView(Views.Mixed)
        break;
      case "btn3":
        var button_id3 = "3";
        var u_id3 = currentUser?.id

        try {
          ApiProvider.post(`/button/${button_id3}/${u_id3}`)

        } catch (err) {
          console.log("Error en el control de clicks.")
        }
        setView(Views.Widgets)
        break;
      case "btn4":
        var button_id4 = "4";
        var u_id4 = currentUser?.id

        try {
          ApiProvider.post(`/button/${button_id4}/${u_id4}`)

        } catch (err) {
          console.log("Error en el control de clicks.")
        }
        setView(Views.Expanded)
        break;
      default:
        setView(Views.Layers)
        break;

    }
  }



  return (
    <div className={panelClasses}>
      <button onClick={() => setHidden(!hidden)} className={styles.panelToggle}>
        <Icon name="exchange-line" />
      </button>

      {loading ? (
        <Loading />
      ) : (
        <>
          <Flex component="header" justify="between" align="center" className={styles.panelHeader}>
            <Logo />
            <div>
              <button
                className={cx(styles.viewButton, view === Views.Layers && styles.active)}
                value="btn1"
                onClick={(e) => monitoreoPanel(e.currentTarget.value)}
              >
                <Tooltip label={t(`tooltips.panel.mapa_capas`)} direction="LEFT_CENTER">
                  <Icon name="stack-line" />
                </Tooltip>
              </button>
              <button
                className={cx(styles.viewButton, view === Views.Mixed && styles.active)}
                value="btn2"
                onClick={(e) => monitoreoPanel(e.currentTarget.value)}
              >
                <Tooltip label={t(`tooltips.panel.mapa_capas_graf`)} direction="LEFT_CENTER">
                  <Icon name="layout-column-fill" />
                </Tooltip>
              </button>
              <button
                className={cx(styles.viewButton, view === Views.Widgets && styles.active)}
                value="btn3"
                onClick={(e) => monitoreoPanel(e.currentTarget.value)}
              >
                <Tooltip label={t(`tooltips.panel.graficos`)} direction="LEFT_CENTER">
                  <Icon name="layout-column-line" />
                </Tooltip>
              </button>
              <button
                className={cx(styles.viewButton, view === Views.Expanded && styles.active)}
                value="btn4"
                onClick={(e) => monitoreoPanel(e.currentTarget.value)}
              >
                <Tooltip label={t(`tooltips.panel.mapa_capas_graf_ext`)} direction="LEFT_CENTER">
                  <Icon name="table-fill" />
                </Tooltip>
              </button>
            </div>
          </Flex>
          {project && (
            <ProjectInfo
              project={project!}
              full={showWidgets}
              area={area}
              showCompareMenu={!isEmpty(project) && showWidgets}
            />
          )}
          <Divider />
          <section className={styles.panelContent}>
            <div className={styles.panelBody}>
              {showLayers && <Layers layers={layers} />}
              {showWidgets && <Widgets double={doubleWidgets} />}
            </div>
          </section>
        </>
      )}
    </div>
  )
}

Panel.displayName = 'Panel'

const Loading: FC = () => (
  <div className={styles.loading}>
    <Icon name="refresh-line" />
  </div>
)
